interface ButtonProps {
    children: React.ReactNode;
    onClick?: () => void;
    id?: string;
    className?: string;
    disabled?: boolean;
}

export const PrimaryButton = ({ children, onClick, className = '', disabled = false }: ButtonProps) => {
    return (
        <button
            id=""
            onClick={onClick}
            disabled={disabled}
            className={`px-2.5 py-4 bg-primary rounded-2xl text-primary-content text-base font-medium font-outfit leading-6 
                hover:bg-[#A1FF87] transition-all duration-200 
                disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
        >
            {children}
        </button>
    );
};